import React, { useEffect, useState } from 'react';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import apiInstance from '../../services/ServiceApi';

const EstadoValidacion = ({ onEstadoChange }) => {
  const [estadosValidacion, setEstadosValidacion] = useState([]);
  const [selectedEstado, setSelectedEstado] = useState('');

  useEffect(() => {
    apiInstance.get('/estados-validacion/')
      .then(response => {
        setEstadosValidacion(response.data);
      })
      .catch(error => console.error('Error:', error));
  }, []);

  const handleEstadoChange = (event) => {
    const selectedEstado = event.target.value;
    setSelectedEstado(selectedEstado);
    onEstadoChange(selectedEstado);
  };

  return (
    <FormControl fullWidth>
      <InputLabel id="demo-simple-select-label">Estado de Validación</InputLabel>
      <Select
        labelId="demo-simple-select-label"
        value={selectedEstado}
        onChange={handleEstadoChange}
        label="Estado de Validación"
      >
        {estadosValidacion.map((estado, index) => (
          <MenuItem key={index} value={estado.id}>{estado.estado_validacion}</MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

export default EstadoValidacion;
